import React from 'react';
import { StickyContainer, Sticky } from 'react-sticky';

import DocumentData from './Components/DocumentData';
import DocumentCanvas from './Components/DocumentCanvas';
import DocumentProperties from './Components/DocumentProperties';

import './style.css';

const CURRENT_STEP = 'DOCUMENT_BUILDER';

export default function DocumentBuilder({ currentStep }) {
  if (currentStep !== CURRENT_STEP) {
    return null;
  }

  return <StickyContainer className="row">
    <div className="col-lg-4">
      <Sticky>
        {({ style }) => (
          <div style={style}>
            <DocumentData />
          </div>
        )}
      </Sticky>
    </div>
    <div className="col-lg-5">
      <DocumentCanvas />
    </div>
    <div className="col-lg-3">
      <Sticky>
        {({ style }) => (
          <div style={style}>
            <DocumentProperties />
          </div>
        )}
      </Sticky>
    </div>
  </StickyContainer>
}